import FixaLink from "../../../shared/wrappers/FixaLink/FixaLink";
import { FixaText } from "../../../shared/wrappers/FixaText/FixaText";
import type { Launch, LaunchMedia } from "../../types/launch";
import { getMediaTypeLabel, normalizeMediaType } from "../../utils/mediaType";
import { MediaCard } from "../MediaCard/MediaCard";
import styles from "./launch-media-section.module.css";

function toMediaCardProps(media: LaunchMedia, launch: Launch) {
  return {
    id: media.id,
    imageUrl: media.preview_images?.[0]?.url ?? "",
    imageAlt: media.name,
    badgeLabel: launch.name,
    title: media.name,
    fiscalYear: media.fiscal_year ?? "",
    mediaType: getMediaTypeLabel(normalizeMediaType(media.media_type)),
    status: media.status ?? ("Unpublished" as const),
    publishedDate: media.published_date ?? "",
  };
}

type LaunchMediaSectionProps = {
  launch: Launch;
  medias: LaunchMedia[];
};

export const LaunchMediaSection = ({
  launch,
  medias,
}: LaunchMediaSectionProps) => {
  return (
    <section className={styles["section"]} aria-label={launch.name}>
      <FixaText tagName="h2" textStyle="Heading.M">
        {launch.name}
      </FixaText>
      <FixaText
        tagName="p"
        textStyle="Heading.S"
        className={styles["results-count"]}
      >
        {medias.length} Results
      </FixaText>

      <div className={styles["grid"]}>
        {medias.map((media) => {
          const card = toMediaCardProps(media, launch);
          return (
            <FixaLink key={card.id} to={`/launch-media/${card.id}`}>
              <MediaCard {...card} />
            </FixaLink>
          );
        })}
      </div>
    </section>
  );
};
